import { apiClient } from "../apiClient";
export const lopApi = {
  SelectAll: () => apiClient.get(`select-all`),
  SelectByNamHoc: (nam_hoc: string) => apiClient.get(`nam-hoc/${nam_hoc}/lop`),
};
